import { FormControl, RadioGroup } from '@material-ui/core'

const ReduxRadioGroup = ({ input, ...rest }: any) => (
  <FormControl>
    <RadioGroup {...input} {...rest}></RadioGroup>
  </FormControl>
)

export default ReduxRadioGroup
